<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" size="small" :ref="searchForm"
          style="margin: 0">
          <el-form-item label="产品名称：">
            <el-input size="medium" placeholder="名称" minlength="10" maxlength="16" v-model="searchForm.NAME" clearable
              @keyup.enter.native="filter"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" placeholder="编码" minlength="10" maxlength="16" v-model="searchForm.CODE" clearable
              oninput="value=value.replace(/[^0-9]/g,'')" @keyup.enter.native="filter"></el-input>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-button size="medium" @click="filter" type="primary" :loading="loadSearch">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-button size="medium" @click="importReferencePriceVisible = true" v-if="fun_dic[103080001]">导入参考价</el-button>
      <el-button size="medium" type="primary" plain @click="exportReferencePrice">导出参考价</el-button>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top: 20px">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="200"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="150"></el-table-column>
          <el-table-column prop="RR_PRICE" label="参考价" min-width="120"></el-table-column>
          <el-table-column prop="START_DAY" label="开始日期" min-width="120"></el-table-column>
          <el-table-column prop="END_DAY" label="结束日期" min-width="120"></el-table-column>
          <el-table-column label="操作" v-if="fun_dic[103080002]">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deleteReferencePrice(scope.row)"
                v-if="fun_dic[103080002]">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 导入参考价 -->
    <el-dialog title="导入参考价" center :visible.sync="importReferencePriceVisible" width="500px">
      <el-form ref="importForm" v-model="importForm" style="margin-left: 30px">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
          :on-remove="handleRemove" :name="this.importForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <p style="color: #409eff" @click="exportReferencePrice">点击下载导入模板</p>
        <p style="color: #F56C6C">※产品单位为斤/公斤时，导入的价格应为每公斤价格</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importReferencePriceVisible = false">取 消</el-button>
        <el-button @click="importReferencePrice">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getActionFun } from '@/assets/api/login';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      tableData: [],
      loadSearch: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      searchForm: {},
      fileList: [],
      importReferencePriceVisible: false,
      importForm: {
        file: 'tmp',
      },
      PAGE_ID: '1030800', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 103080001: 0, 103080002: 0 },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryReferencePrice();
    this.queryBeforeFun();
  },
  computed: {},
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryReferencePrice();
    },
    // 筛选
    filter() {
      this.currentPage = 1;
      this.queryReferencePrice();
    },
    // 拉取数据
    queryReferencePrice() {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 39,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
      };
      if (this.searchForm.CODE) {
        params.PRODUCT_CODE = this.searchForm.CODE;
      }
      if (this.searchForm.NAME) {
        params.PRODUCT_NAME = this.searchForm.NAME;
      }
      if (this.searchForm.DAY_INTERVAL) {
        [params.strStartDay, params.strEndDay] = this.searchForm.DAY_INTERVAL;
      }
      this.loadSearch = true;
      http.post(params).then((res) => {
        this.tableData = res[0].LIST;
        this.totalCount = res[0].TOTAL_COUNT;
        this.loadSearch = false;
      }).catch((err) => {
        this.loadSearch = false;
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 导入业务参考价
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    // 导入模态框的提交
    importReferencePrice() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 41,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        FILE_NAME: this.url,
      };
      http.post(params)
        .then((result) => {
          if (!result[0]) {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.importReferencePriceVisible = false;
            this.fileList = [];
            this.queryReferencePrice();
            document.body.style.cursor = 'default';
          } else {
            this.$message.show({ text: '部分产品导入异常，详情查看下载文件', type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.importReferencePriceVisible = false;
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.fileList = [];
            document.body.style.cursor = 'default';
            this.queryReferencePrice();
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.url = '';
          this.$refs.upload.clearFiles();
          document.body.style.cursor = 'default';
        });
    },
    // 导出业务参考价
    exportReferencePrice() {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 40,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.DAY_INTERVAL) {
        [params.strStartDay, params.strEndDay] = this.searchForm.DAY_INTERVAL;
      }
      http.post(params)
        .then((result) => {
          document.body.style.cursor = 'default';
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          document.body.style.cursor = 'default';
        });
    },
    // 删除参考价记录
    deleteReferencePrice(row) {
      this.$confirm('您确定删除这条记录吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          const params = {
            SERVICE_ID: '10008',
            OTYPE: 42,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            RECORD_ID: row.RECORD_ID,
          };
          http.post(params)
            .then((result) => {
              this.$message.show({ text: '删除成功', type: 'success' });
              this.queryReferencePrice();
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
            });
        }).catch(() => {
          this.$message.show({ type: 'info', text: '取消操作' });
        });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/priceManagement/businessReferencePrice.vue